import React from "react";
import PlanOverride from "../../../pages/LookUps/PlanOverride/PlanOverride";
import BenefitMaxSchedule from "../../../pages/BenefitMaxSchedule/BenefitMaxSchedule";
import OutOfPocketMaxSchedule from "../../../pages/OutofPocketSchedule/OutofPocketMaxSchedule";
import DeductibleSchedule from "../../../pages/DeductibleSchedule/DeductibleSchedule";
import TroopSchedule from "../../../pages/TroopSchedule/TrOOPSchedule";
import BenefitMaxScheduleForm from "../../../pages/BenefitMaxSchedule/BenefitMaxScheduleForm";
import OutofPocketForm from "../../../pages/OutofPocketSchedule/OutofPocketForm";
import { PRICE_SCHEDULE_MODES } from "../../utils/Constants";
import DeductibleScheduleForm from "../../../pages/DeductibleSchedule/DeductibleScheduleForm";
import TroopScheduleForm from "../../../pages/TroopSchedule/TrOOPScheduleForm";

const ConditionalLookup = ({
  screenNumber,
  params,
  receiveData,
  hideModal,
  sourceData,
  conditionalKey = "aosAccumOvrdScdeType",
  readOnly = false,
  onNavigate,
}) => {
  //const { aosAccumOvrdScdeType } = sourceData;
  const lookupScreen = screenNumber[sourceData[conditionalKey]];
  const { lookupType, fieldMapping } = params;
  console.log("in local", lookupType, lookupScreen, params);
  const selectParams = fieldMapping[sourceData[conditionalKey]];
  const paramsData = selectParams.reduce((acc, item) => {
    acc[item["target"]] = sourceData[item["source"]];
    return acc;
  }, {});
  console.log("read only data", paramsData, selectParams);
  switch (lookupScreen) {
    /* case "RCPLN018":
      return (
        <PlanOverride
          params={fieldMapping[sourceData[conditionalKey]]}
          onSelect={receiveData}
          hideModal={hideModal}
          lookupType={lookupType}
        />
      ); */
    case "RCBSC005":
      if (readOnly) {
        return (
          <BenefitMaxScheduleForm
            mode={PRICE_SCHEDULE_MODES.READ_ONLY}
            selectMode={true}
            selectedSchedule={[paramsData]}
            hideModal={hideModal}
          />
        );
      }
      return (
        <BenefitMaxSchedule
          params={fieldMapping[sourceData[conditionalKey]]}
          onSelect={receiveData}
          hideModal={hideModal}
          selectMode={true}
          lookupType={lookupType}
          selectModeParamData={paramsData}
          onNavigate={onNavigate}
        />
      );
    case "RCOPC005":
      if (readOnly) {
        return (
          <OutofPocketForm
            mode={PRICE_SCHEDULE_MODES.READ_ONLY}
            selectMode={true}
            selectedSchedule={[paramsData]}
            hideModal={hideModal}
          />
        );
      }
      return (
        <OutOfPocketMaxSchedule
          params={fieldMapping[sourceData[conditionalKey]]}
          onSelect={receiveData}
          hideModal={hideModal}
          selectMode={true}
          lookupType={lookupType}
          selectModeParamData={paramsData}
          onNavigate={onNavigate}
        />
      );
    case "RCDSC005":
      if (readOnly) {
        return (
          <DeductibleScheduleForm
            mode={PRICE_SCHEDULE_MODES.READ_ONLY}
            selectMode={true}
            selectedSchedule={[paramsData]}
            hideModal={hideModal}
          />
        );
      }
      return (
        <DeductibleSchedule
          params={fieldMapping[sourceData[conditionalKey]]}
          onSelect={receiveData}
          hideModal={hideModal}
          selectMode={true}
          lookupType={lookupType}
          selectModeParamData={paramsData}
          onNavigate={onNavigate}
        />
      );
    case "RCTSC003":
      if (readOnly) {
        return (
          <TroopScheduleForm
            mode={PRICE_SCHEDULE_MODES.READ_ONLY}
            selectMode={true}
            selectedCode={[paramsData]}
            hideModal={hideModal}
          />
        );
      }
      return (
        <TroopSchedule
          params={fieldMapping[sourceData[conditionalKey]]}
          onSelect={receiveData}
          hideModal={hideModal}
          selectMode={true}
          lookupType={lookupType}
          selectModeParamData={paramsData}
          onNavigate={onNavigate}
        />
      );
    default:
      return null;
  }
};
export default ConditionalLookup;
